export const ROAD_CARE_PLAN_TYPES = {
  DEFAULT: 'DEFAULT',
};
export const ROAD_CARE_MAX_AGE = 100;
export const ROAD_CARE_SEARCH_VEHICLE_REQUIRED_FIELDS = ['plateNumber', 'passport', 'hasAgreed'];
export const ROAD_CARE_SEARCH_VEHICLE_BACKEND_ERROR_MESSAGES = [
  'no_vehicle_match',
  'no_document_match',
  'vehicle_not_found',
  'vehicle_older_than_expected',
  'no_light_passenger_vehicle',
];
export const ROADCARE_PREFIX = 'roadcare';
export const ROAD_CARE_CONTRACT_LINK = {
  hy: 'https://www.efes.am/roadcareassitance',
  en: 'https://www.efes.am/en/roadcareassitance',
};
